import { render, staticRenderFns } from "./InvoiceViewPayments.vue?vue&type=template&id=45bf76ee&"
import script from "./InvoiceViewPayments.vue?vue&type=script&lang=js&"
export * from "./InvoiceViewPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports